const VIDEO_BASE_URL = process.env.NEXT_PUBLIC_IMAGE_BASE_URL;

if (!VIDEO_BASE_URL) {
  console.log("NEXT_PUBLIC_IMAGE_BASE_URL ENV is Required for Video")
}

export const Videos = {
  modelVideo2: `${VIDEO_BASE_URL}/public/video/hero-content.mp4`,
  approachBrand: `${VIDEO_BASE_URL}/video/approach-brand.mp4`,
  contact: `${VIDEO_BASE_URL}/video/contact.mp4`,
  career: `${VIDEO_BASE_URL}/video/career-video.mp4`,
  web: `${VIDEO_BASE_URL}/video/web.mp4`,
  mobile: `${VIDEO_BASE_URL}/video/mobile.mp4`,
  laravel: `${VIDEO_BASE_URL}/video/laravel.mp4`,
  modelVideo: `${VIDEO_BASE_URL}/video/future-ready.mp4`,
  modelVideo3: `${VIDEO_BASE_URL}/video/technology.mp4`,
  trophy: `${VIDEO_BASE_URL}/video/trophy.mp4`,
  technology: `${VIDEO_BASE_URL}/video/technology-2.mp4`,
  futureReady: `${VIDEO_BASE_URL}/video/video/future-ready.mp4`,
  career2: `${VIDEO_BASE_URL}/video/career.mp4`,
  blob: `${VIDEO_BASE_URL}/video/blob.mp4`,
  testimonialVideo: `${VIDEO_BASE_URL}/video/testimonial.mp4`,
  clientReview1: `${VIDEO_BASE_URL}/video/testimonial.mp4`,
  clientReview2: `${VIDEO_BASE_URL}/public/video/client_review_1.mp4`,
  clientReview3: `${VIDEO_BASE_URL}/public/video/client_review_2.mp4`,
} as const;

export default Videos;
